import { initializeDatasets } from '@libs/datasets';

import datasets from './redux.datasets';
import { UPDATE_LEAVE_STATUS, FETCH_EMPLOYEES_FOR_CREATE_LEAVE_REQUEST, FETCH_EMPLOYEES_FOR_CREATE_LEAVE_SUCCESS, FETCH_EMPLOYEES_FOR_CREATE_LEAVE_FAILURE } from './redux.actionTypes';

const initialState = {
    ...initializeDatasets(datasets),
    employeesForCreateLeave: {
        loading: false,
        data: [],
        error: null,
    },
};

export default (state = initialState, { type, payload, ...action }) => {
    switch (type) {
        case UPDATE_LEAVE_STATUS: {
            const { entity, value, key = "id" } = payload;
            const { data } = state[entity];
            let allEntries = [...data];
            const index = allEntries.findIndex((item) => (item[key] === value[key]));

            if (index === -1) return state;

            allEntries[index].status = value.status;
            return { ...state, [entity]: { ...state[entity], data: allEntries } };
        }
        case FETCH_EMPLOYEES_FOR_CREATE_LEAVE_REQUEST: {
            return {
                ...state,
                employeesForCreateLeave: {
                    ...state.employeesForCreateLeave,
                    loading: true,
                    error: null,
                },
            };
        }
        case FETCH_EMPLOYEES_FOR_CREATE_LEAVE_SUCCESS: {
            return {
                ...state,
                employeesForCreateLeave: {
                    ...state.employeesForCreateLeave,
                    loading: false,
                    data: payload || [],
                    error: null,
                },
            };
        }
        case FETCH_EMPLOYEES_FOR_CREATE_LEAVE_FAILURE: {
            return {
                ...state,
                employeesForCreateLeave: {
                    ...state.employeesForCreateLeave,
                    loading: false,
                    error: payload,
                },
            };
        }
        default: {
            return state;
        }
    }
};
